export default "__VITE_ASSET__DmiPWPZf__"